<div *ngIf="params?.data?.isExpandable" class="container-fluid expand-row px-0 w-100">
  <div class="row mx-0 my-auto flex-nowrap w-100">
    <div class="first-col">
      <div class="row mx-0 mt-2 mb-1">
        <div class="col-4">
          <p class="text-light-gray font-14 mb-0">RoHS</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.roHS ? params?.data?.roHS: "-" }}
          </p>
        </div>
        <div class="col-4">
          <p class="text-light-gray font-14 mb-0">COO</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.coo ? params?.data?.coo: "-" }}
          </p>
        </div>
        <div class="col-4">
          <p class="text-light-gray font-14 mb-0">Need Date</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.needDate ? params?.data?.needDate:"-" }}
          </p>
        </div>
      </div>
      <div class="row mx-0 mb-1">
        <div class="col-4">
          <p class="text-light-gray font-14 mb-0">Condition</p>
          <p class="text-primary-color mb-2 font-14 text-truncate mb-0">
            {{ params?.data?.condition ? params?.data?.condition: "-" }}
          </p>
        </div>
        <div class="col-4 minw-0">
          <p class="text-light-gray font-14 mb-0 text-truncate">Target Buy Price</p>
          <p class="text-primary-color mb-2 font-14 text-truncate mb-0">
            {{ params?.data?.targetBuyPrice ? params?.data?.targetBuyPrice: "-" }}
          </p>
        </div>
        <div class="col-4 minw-0">
          <p class="text-light-gray font-14 mb-0 text-truncate">Customer Notes</p>
          <p class="text-primary-color mb-2 font-14 text-truncate mb-0">
            {{ params?.data?.customerNotes ? params?.data?.customerNotes:"-" }}
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row mx-0 mt-2 mb-1">
        <div class="col-2 minw-0">
          <p class="text-light-gray font-14 mb-0 text-truncate">Opportunity Type</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.opportunityType ? params?.data?.opportunityType: "-" }}
          </p>
        </div>
        <div class="col-2 minw-0">
          <p class="text-light-gray font-14 mb-0 text-truncate">Close Probability</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.closeProbability ? params?.data?.closeProbability: "-" }}
          </p>
        </div>
        <div class="w-22 minw-0">
          <p class="text-light-gray font-14 mb-0 text-truncate">End Customer/Industry</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.endCustomerIndustry ? params?.data?.endCustomerIndustry:"-" }}
          </p>
        </div>
        <div class="col-2">
          <p class="text-light-gray font-14 mb-0">Project Name</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.projectName ? params?.data?.projectName:"-" }}
          </p>
        </div>
        <div class="col-2">
          <p class="text-light-gray font-14 mb-0">Application</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.application ? params?.data?.application:"-" }}
          </p>
        </div>
        <div class="col minw-0">
          <p class="text-light-gray font-14 mb-0 text-truncate">Project Approved</p>
          <p class="text-primary-color mb-2 font-14 text-truncate">
            {{ params?.data?.projectApproved === true ? 'Yes':"No" || '-' }}
          </p>
        </div>
      </div>
      <div class="row mx-0 mb-1">
        <div class="col-4">
          <p class="text-light-gray font-14 mb-0">Opportunity Notes</p>
          <p class="text-primary-color mb-2 font-14 text-truncate mb-0">
            {{ params?.data?.opportunityNotes ? params?.data?.opportunityNotes : "-" }}
          </p>
        </div>
        <div class="w-22">
          <p class="text-light-gray font-14 mb-0">Bid Deadline</p>
          <p class="text-primary-color mb-2 font-14 text-truncate mb-0">
            {{ params?.data?.bidDeadline ? params?.data?.bidDeadline : "-" }}
          </p>
        </div>
        <div class="col">
          <p class="text-light-gray font-14 mb-0">Est.Start Date</p>
          <p class="text-primary-color mb-2 font-14 text-truncate mb-0">
            {{ params?.data?.estStartDate ? params?.data?.estStartDate:"-" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>